import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocationTab } from "src/hooks/UseLocationTab";
import {
  ORGANIC_TAB_ITEMS,
  ORGANIC_TAB_I18N_KEYS,
} from "./OrganicTabsDashboard.data";
import FacebookContentReport from "./FacebookContentReport/FacebookContentReport";
import InstagramContentReport from "./InstagramContentReport/InstagramContentReport";
import FacebookFollowersReport from "./FacebookFollowersReport/FacebookFollowersReport";
import InstagramFollowersReport from "./InstagramFollowersReport/InstagramFollowersReport";
import "../../styles/OrganicTabsDashboard.scss";

const toISODate = (date: Date) => date.toISOString().slice(0, 10);

const getDefaultDateRange = () => {
  const end = new Date();
  const start = new Date(end);
  start.setDate(start.getDate() - 30);

  return {
    startDate: toISODate(start),
    endDate: toISODate(end),
  };
};

const OrganicTabsDashboard: FC = () => {
  const { t } = useTranslation();
  const [defaultDateRange] = useState(getDefaultDateRange);
  const [activeTab, setActiveTab] = useLocationTab(ORGANIC_TAB_ITEMS, "facebook-content");
  const [appliedStartDate, setAppliedStartDate] = useState(defaultDateRange.startDate);
  const [appliedEndDate, setAppliedEndDate] = useState(defaultDateRange.endDate);
  const [draftStartDate, setDraftStartDate] = useState(defaultDateRange.startDate);
  const [draftEndDate, setDraftEndDate] = useState(defaultDateRange.endDate);
  const [topCountriesCount, setTopCountriesCount] = useState<
    number | undefined
  >();
  const [topCitiesCount, setTopCitiesCount] = useState<number | undefined>();
  const [instagramTopCountriesCount, setInstagramTopCountriesCount] = useState<
    number | undefined
  >();
  const [instagramTopCitiesCount, setInstagramTopCitiesCount] = useState<
    number | undefined
  >();

  const todayISO = new Date().toISOString().slice(0, 10);

  const handleApplyDates = ({
    startDate,
    endDate,
  }: {
    startDate: string;
    endDate: string;
  }) => {
    setDraftStartDate(startDate);
    setDraftEndDate(endDate);
    setAppliedStartDate(startDate);
    setAppliedEndDate(endDate);
  };

  const dateFilters = {
    appliedStartDate,
    appliedEndDate,
    draftStartDate,
    draftEndDate,
    onApplyDates: handleApplyDates,
  };

  return (
    <div className="organic-tabs-dashboard">
      <div className="organic-tabs-dashboard__tabs">
        {ORGANIC_TAB_ITEMS.map(tabId => (
          <button
            key={tabId}
            type="button"
            className={`organic-tabs-dashboard__tab ${
              activeTab === tabId ? "organic-tabs-dashboard__tab--active" : ""
            }`}
            onClick={() => setActiveTab(tabId)}
          >
            {t(ORGANIC_TAB_I18N_KEYS[tabId])}
          </button>
        ))}
      </div>

      {activeTab === "facebook-content" ? (
        <FacebookContentReport
          dateFilters={dateFilters}
        />
      ) : activeTab === "instagram-content" ? (
        <InstagramContentReport
          dateFilters={dateFilters}
        />
      ) : activeTab === "facebook-followers" ? (
        <FacebookFollowersReport
          dateFilters={dateFilters}
          topCountriesCount={topCountriesCount}
          topCitiesCount={topCitiesCount}
          setTopCountriesCount={setTopCountriesCount}
          setTopCitiesCount={setTopCitiesCount}
          todayISO={todayISO}
        />
      ) : activeTab === "instagram-followers" ? (
        <InstagramFollowersReport
          dateFilters={dateFilters}
          instagramTopCountriesCount={instagramTopCountriesCount}
          instagramTopCitiesCount={instagramTopCitiesCount}
          setInstagramTopCountriesCount={setInstagramTopCountriesCount}
          setInstagramTopCitiesCount={setInstagramTopCitiesCount}
          todayISO={todayISO}
        />
      ) : (
        <div className="organic-tabs-dashboard__coming-soon">{t("organicMedia.comingSoon")}</div>
      )}
    </div>
  );
};

export default OrganicTabsDashboard;
